import { Component, Inject, OnInit  } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from "@angular/forms";
import { User, Owner } from '../../../modele/user/userModel';
import {SnackbarComponent} from '../../../components/alerts/snackbar/snackbar.component';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Board, UserRelatedBoard} from '../../../modele/boardModel';
import {BoardService} from "../../../services/board/board.service";
import {EndpointService} from "../../../services/endpoint/endpoint.service";


export interface DialogDeleteBoardData {
  board_name: string;
  board_id: any;
  array: Array<UserRelatedBoard>;
  index: any;
}

@Component({
  selector: 'app-dialog-delete-board',
  templateUrl: './dialog-delete-board.component.html',
  styleUrls: ['./dialog-delete-board.component.scss']
})
export class DialogDeleteBoardComponent implements OnInit {
    private lp:string=this.constructor.name;
        board_name:string="";
        user_name:string="";
        contactFormGroup: FormGroup;
        local_user:User;


        constructor(
          private formBuilder: FormBuilder,
          private router: Router,
          private boardService: BoardService,
          private endpointSrv: EndpointService,
          private snackBar: MatSnackBar,
          public dialogRef: MatDialogRef<DialogDeleteBoardComponent>,
          @Inject(MAT_DIALOG_DATA) public data: DialogDeleteBoardData) {
            this.board_name = this.router.url.substr(1);

        }

        ngOnInit() {

        }

          onNoClick(): void {
            this.dialogRef.close();
          }

          submit(i) {
              this.endpointSrv.getBackendDeleteBoard(this.data.board_id).subscribe(data=>{
                  this.snackBar.openFromComponent(SnackbarComponent, {
                      panelClass: "snackbar",
                      duration: 1500,
                      horizontalPosition: 'center',
                      data: {
                          message: 'keyword_$235',
                          icon: 'delete'
                      }
                  });
              })

              this.dialogRef.close();

          }

    }
